import { LOGGER } from "../utils/logger";
import useAxios from "../utils/interceptor";

const RoleApi = () => {
  const axiosHandler = useAxios();

  const getAll = async () => {
    try {
      const res = await axiosHandler.get(`role/all`);
      return res?.data;
    } catch (error) {
      LOGGER.error({ text: "getAll api ", error });
    }
  };

  const getAllPagination = async ({ page = 0, pageSize = 10, search = "" }) => {
    try {
      const res = await axiosHandler.get(
        `role?page=${page}&pageSize=${pageSize}&search=${search}`
      );
      return res?.data;
    } catch (error) {
      LOGGER.error({ text: "getAll api ", error });
    }
  };

  const create = async (body) => {
    try {
      const res = await axiosHandler.post(`role`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "create api ", error });
      return {
        text: "create api error",
        error,
      };
    }
  };

  const update = async (body, id) => {
    try {
      const res = await axiosHandler.put(`role/${id}`, body);
      return res;
    } catch (error) {
      LOGGER.error({ text: "update api ", error });
    }
  };

  const remove = async (id) => {
    try {
      const res = await axiosHandler.delete(`role/${id}`);
      return res;
    } catch (error) {
      LOGGER.error({ text: "delete api ", error });
    }
  };

  return {
    getAllPagination,
    create,
    getAll,
    update,
    remove,
  };
};

export default RoleApi;
